module.exports = __webpack_public_path__ + "static/media/colx.94b57c1d.svg";